import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Purchase = () => {
  return (
    <motion.div
      className="dashboard-element-bg py-6 rounded-2xl"
      id="pricing"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="container mx-auto">
        <div className="flex flex-wrap">
          <div className="w-full">
            <div className="flex flex-wrap">
              <motion.div
                className="w-full lg:w-1/2 flex items-center"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
              >
                <div className="left-content show-up header-text">
                  <div className="flex flex-wrap">
                    <div className="container mx-auto">
                      <div className="flex flex-wrap">
                        <div className="w-full">
                          <div className="purchase-heading">
                            <h4>The price will never be <em>Better</em></h4>
                            <div className="line-dec"></div>
                            <br />
                            <h5 className="text-xl text-white">
                              Lock in the Founder's rate by joining now.
                              <br />
                              <br />
                            </h5>
                            <ul className="list-disc text-white">
                              <li><strong>Early Access</strong>: Get on before others and claim your space!</li>
                              <li><strong>Unlimited People</strong>: You will have no limit to how many people you can have per group!</li>
                              <li><strong>Unlimited Groups</strong>: You will have no limit to how many groups you can integrate!</li>
                              <li><strong>Product Influence</strong>: Your feedback is important to us and will define the direction of the product!</li>
                              <li><strong>All Features Included</strong>: In the Beta package, nothing is or will be off limits!</li>
                            </ul>
                            <div className="center mt-16 text-white" style={{ width: '95%' }}>
                              <h4 className='flex justify-center items-center'>
                                <br />
                                <u><strong>Happiness Guarantee</strong></u> <span className="checkmark-payment pl-3"><img src="assets/images/green-check.png" alt="" /></span>
                              </h4>
                              <h7>
                                Our mission is to build the Church. We want to do whatever it takes to level up your church so you can reach more people for Jesus.
                                If JoltChat doesn't help you do that, we will refund your money. No questions asked. If you've got questions about our product or you would like us to
                                build a feature that would better serve you, please let us know. <br />Happiness. Guaranteed.
                              </h7>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
              <motion.div
                className="w-full lg:w-1/3 flex items-center ml-10"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
              >
                <div className="right-pricing z-10 w-full max-w-4xl mx-auto relative">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-4">
                    {/* Basic Plan */}
                    <div className="pricing-card bg-gray-100 p-4 rounded-lg shadow-lg flex flex-col justify-between transform scale-95 opacity-75 absolute top-0 left-0 z-0">
                      <h2 className="price-heading !text-gray-400">Basic</h2>
                      <div className="price-grey text-center">
                        <span className="amount text-4xl font-bold">$175</span>
                        <span className="period text-lg">per month</span>
                      </div>
                    </div>
                
                    {/* Founders Plan */}
                    <div className="pricing-card bg-blue-500 text-white p-4 rounded-lg shadow-lg flex flex-col justify-between transform scale-105 relative z-10 mx-auto">
                      <h2 className="price-heading">JoltChat <i className="fire-text" style={{ color: '#fff', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)' }}>Founders</i></h2>
                      <div className="price text-center">
                        <span className="amount text-4xl font-bold text-black py-3">$97</span>
                        <span className="period text-lg">per month</span>
                      </div>
                      <ul className="beta-offer-list list-disc pl-5 text-left">
                        <li>Early Access</li>
                        <li>Unlimited People</li>
                        <li>Unlimited Groups</li>
                        <li>All Features Included</li>
                      </ul>
                      <div className="w-full mt-4">
                        <div className="cta-small-button scroll-to-section">
                          <a href="https://buy.stripe.com/9AQ7vm9IH0NfaYw5kl" className="bg-white text-blue-500 py-2 px-4 rounded-full">Become a Member</a>
                        </div>
                      </div>
                    </div>
                
                    {/* Premium Plan */}
                    <div className="pricing-card bg-gray-100 p-4 rounded-lg shadow-lg flex flex-col justify-between transform scale-95 opacity-75 absolute top-0 right-0 left-16 z-0">
                      <h2 className="price-heading !text-gray-400">Premium</h2>
                      <div className="price-grey text-center">
                        <span className="amount text-4xl font-bold">$250</span>
                        <span className="period text-lg">per month</span>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Purchase;